export const SITE_URL = 'https://www.nhadepwoodplus.com';
export const SITE_NAME = 'WoodPlus';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/images/homepage/homePageHero1.jpg`;
